import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AdvancedForm } from "@magieno/angular-advanced-forms";

@Injectable({
  providedIn: 'root',
})
export class FormChangeManager {
  public readonly formChange: Subject<AdvancedForm<any>> = new Subject<AdvancedForm<any>>();

  formHasChanged(form: AdvancedForm<any>) {
    this.formChange.next(form);
  }
}